import { format } from 'date-fns';
import { CommonUtilities } from '../../commonUtils';

export default class metaDataServices {



    static ContractAssetheaderMapping = [
        {
            assetType: "Tracks", tabName: "contractTracks",
            field_display: ["ISRC", "TrackSeq", "Artist", "Title", "% Owned"],
            field_code: ["iSRC", "trackSeq", "kontactName", "trackName", "percentageOwned"],
        },

        {
            assetType: "Tracks", tabName: "unlinkedTracks",
            field_display: ["ISRC", "TrackSeq", "Artist", "Title", "% Owned"],
            field_code: ["iSRC", "trackSeq", "kontactName", "trackName", "percentageOwned"],
        },

        {
            assetType: "Tracks", tabName: "releaseTracks",
            field_display: ["ISRC", "TrackSeq", "Artist", "Title", "% Owned"],
            field_code: ["iSRC", "trackSeq", "kontactName", "trackName", "percentageOwned"],
        },

        {
            assetType: "Tracks", tabName: "linkedTracks",
            field_display: ["ISRC", "contractRefNum", "TrackSeq", "Artist", "Title", "% Owned"],
            field_code: ["iSRC", "contractRefNum", "trackSeq", "kontactName", "trackName", "percentageOwned"],
        },



        {
            assetType: "Songs", tabName: "contractSongs",
            field_display: ["Song Ref", "Song Title", "Song Main Composer", "Song Main Publisher", "ISWC", "% Owned"],
            field_code: ["songRef", "songName", "songMainComposer", "songMainPublisher", "intStdWorkCode", "percentageOwned"],
        },
        {
            assetType: "Songs", tabName: "unlinkedSongs",
            field_display: ["Song Ref", "Song Title", "Song Main Composer", "Song Main Publisher", "ISWC", "% Owned"],
            field_code: ["songRef", "songName", "songMainComposer", "songMainPublisher", "intStdWorkCode", "percentageOwned"],
        },

        {
            assetType: "Songs", tabName: "releaseSongs",
            field_display: ["Song Ref", "Song Title", "Song Main Composer", "Song Main Publisher", "ISWC", "% Owned"],
            field_code: ["songRef", "songName", "songMainComposer", "songMainPublisher", "intStdWorkCode", "percentageOwned"],
        },

        {
            assetType: "Songs", tabName: "linkedSongs",
            field_display: ["Song Ref", "Song Title", "Song Main Composer", "Song Main Publisher", "contractRefNum", "ISWC", "% Owned"],
            field_code: ["songRef", "songName", "songMainComposer", "songMainPublisher", "contractRefNum", "intStdWorkCode", "percentageOwned"],
        },


    ]





    static songSplitsListing(data: any) {
        var url = 'publishing/songSplits/list?' + CommonUtilities.buildQueryString(data, true, true);
        return CommonUtilities.getData(url);
    }

    static getPublishingTypes() {
        var url = 'release/getPublishingTypes';
        return CommonUtilities.getData(url);
    }

    static territoryRegionList() {
        var url = 'contracts/territoryRegionList/';
        return CommonUtilities.getData(url);
    }

    static songReference() {
        var url = 'publishing/song/songReference/list';
        return CommonUtilities.getData(url);
    }

    static controlPanelsearchType(data: any) {
        var url = 'contracts/controlPanel/searchType?' + CommonUtilities.buildQueryString(data, true, true);
        return CommonUtilities.getData(url);
    }

    static territoryCode(data: any) {
        var url = 'contracts/territoryCode?' + CommonUtilities.buildQueryString(data, true, true);
        return CommonUtilities.getData(url);
    }

    /****************************************************************************************
    ********************************Cue Management********************************
    ****************************************************************************************/
    static cueSave(data: any) {
        var url = 'cue/save';
        return CommonUtilities.postData(url, data);
    }

    static cueDelete(data: any) {
        var url = 'cue/delete/' + data;
        return CommonUtilities.deleteData(url);
    }

    static cuelistSearch(data: any) {
        var url = 'cue/listSearch?' + CommonUtilities.buildQueryString(data, true, true);
        return CommonUtilities.getData(url);
    }

    static cueProductSave(data: any) {
        var url = 'cue/cueProduct/save';
        return CommonUtilities.postData(url, data);
    }

    static cueProductDelete(data: any) {
        var url = 'cue/cueProduct/delete/' + data;
        return CommonUtilities.postData(url, data);
    }

    static cueSeriesSave(data: any) {
        var url = 'cue/cueSeries/save';
        return CommonUtilities.postData(url, data);
    }

    static cueSeriesDelete(data: any) {
        var url = 'cue/cueSeries/delete/' + data;
        return CommonUtilities.postData(url, data);
    }

    static cueSongsSave(data: any) {
        var url = 'cue/cueSongs/save';
        return CommonUtilities.postData(url, data);
    }

    static cueSongsDelete(data: any) {
        var url = 'cue/cueSongs/delete/' + data;
        return CommonUtilities.postData(url, data);
    }

    static cueProductlistSearch(data: any) {
        var url = 'cue/cueProduct/listSearch?' + CommonUtilities.buildQueryString(data, true, true);
        return CommonUtilities.getData(url);
    }

    static cueProductgetById(data: any) {
        var url = 'cue/cueProduct/getById/' + data;
        return CommonUtilities.getData(url);
    }

    static productionList(data: any) {
        var url = 'synch/project/production/list?' + CommonUtilities.buildQueryString(data, true, true);
        return CommonUtilities.getData(url);
    }


    static cueSerieslistSearch(data: any) {
        var url = 'cue/cueSeries/listSearch?' + CommonUtilities.buildQueryString(data, true, true);
        return CommonUtilities.getData(url);
    }

    static cueSongslistSearch(data: any) {
        var url = 'cue/cueSongs/listSearch?' + CommonUtilities.buildQueryString(data, true, true);
        return CommonUtilities.getData(url);
    }


    /****************************************************************************************
    ********************************cast Management********************************
    ****************************************************************************************/
    static castSave(data: any) {
        var url = 'cast/save';
        return CommonUtilities.postData(url, data);
    }

    static castDelete(data: any) {
        var url = 'cast/delete/' + data;
        return CommonUtilities.deleteData(url);
    }

    static castListSearch(data: any) {
        var url = 'cast/listSearch?' + CommonUtilities.buildQueryString(data, true, true);
        return CommonUtilities.getData(url);
    }

    static castProductSave(data: any) {
        var url = 'cast/castProduct/save';
        return CommonUtilities.postData(url, data);
    }

    static castProductDelete(data: any) {
        var url = 'cast/castProduct/delete/' + data;
        return CommonUtilities.postData(url, data);
    }

    static castSeriesSave(data: any) {
        var url = 'cast/castSeries/save';
        return CommonUtilities.postData(url, data);
    }

    static castSeriesDelete(data: any) {
        var url = 'cast/castSeries/delete/' + data;
        return CommonUtilities.postData(url, data);
    }

    static castSongsSave(data: any) {
        var url = 'cast/castSongs/save';
        return CommonUtilities.postData(url, data);
    }

    static castSongsDelete(data: any) {
        var url = 'cast/castSongs/delete/' + data;
        return CommonUtilities.postData(url, data);
    }

    static castProductListSearch(data: any) {
        var url = 'cast/castProduct/listSearch?' + CommonUtilities.buildQueryString(data, true, true);
        return CommonUtilities.getData(url);
    }

    static castProductgetById(data: any) {
        var url = 'cast/castProduct/getById/' + data;
        return CommonUtilities.getData(url);
    }

    static castSerieslistSearch(data: any) {
        var url = 'cast/castSeries/listSearch?' + CommonUtilities.buildQueryString(data, true, true);
        return CommonUtilities.getData(url);
    }

    static castSongsListSearch(data: any) {
        var url = 'cast/castSongs/listSearch?' + CommonUtilities.buildQueryString(data, true, true);
        return CommonUtilities.getData(url);
    }

    /****************************************************************************************
    ********************************Common APIS********************************
    ****************************************************************************************/
    static cueSheetTypelistSearch() {
        var url = 'cue/cueSheetType/listSearch' //+ CommonUtilities.buildQueryString(data, true, true);
        return CommonUtilities.getData(url);
    }
    static statusProductList(data: any) {
        var url = 'common/statusProduct/list?' + CommonUtilities.buildQueryString(data, true, true);
        return CommonUtilities.getData(url);
    }

    static statusProductExtList(data: any) {
        var url = 'common/statusProductExt/list?' + CommonUtilities.buildQueryString(data, true, true);
        return CommonUtilities.getData(url);
    }


    /****************************************************************************************
    ********************************song Management********************************
    ****************************************************************************************/
    static publishingSongList(data: any) {
        var url = 'publishing/song/list?' + CommonUtilities.buildQueryString(data, true, true);
        return CommonUtilities.getData(url);
    }

    static songSplitslistIPI(data: any) {
        var url = 'publishing/songSplits/listIPI?' + CommonUtilities.buildQueryString(data, true, true);
        return CommonUtilities.getData(url);
    }
    static cueSongsList(data: any) {
        var url = 'cue/cueSongs/listLink?' + CommonUtilities.buildQueryString(data, true, true);
        return CommonUtilities.getData(url);
    }

    static updateCueSongs(data: any) {
        var url = 'cue/cueSongs/updateCueSongs';
        return CommonUtilities.postData(url, data);
    }

    static castSongsList(data: any) {
        var url = 'cue/cueSongs/listLink?' + CommonUtilities.buildQueryString(data, true, true);
        return CommonUtilities.getData(url);
    }

    static updateCastSongs(data: any) {
        var url = 'cue/cueSongs/updateCueSongs';
        return CommonUtilities.postData(url, data);
    }




    /****************************************************************************************
    ********************************contract Link Track********************************
    ****************************************************************************************/
    static contractLinkTrack(data: any) {
        var url = 'contracts/compilation/tracks/link?' + CommonUtilities.buildQueryString(data, true, true);
        return CommonUtilities.getData(url);
    }

    static contractNonLinkTrack(data: any) {
        var url = 'contracts/compilation/tracks/notLink?' + CommonUtilities.buildQueryString(data, true, true);
        return CommonUtilities.getData(url);
    }
    static contractTrackotherContract(data: any) {
        var url = 'contracts/compilation/tracks/otherContract?' + CommonUtilities.buildQueryString(data, true, true);
        return CommonUtilities.getData(url);
    }
    static contractTrackReleaseContract(data: any) {
        var url = 'contracts/compilation/tracks/release?' + CommonUtilities.buildQueryString(data, true, true);
        return CommonUtilities.getData(url);
    }

    static unLinkContractTrack(data: any, contract: any) {
        var url = 'contracts/compilation/tracks/' + contract + '/unLink';
        return CommonUtilities.postData(url, data);
    }

    static linkTrackToContract(data: any, contract: any) {
        var url = 'contracts/compilation/linkTrackToContract/' + contract;
        return CommonUtilities.postData(url, data);
    }

    static genericListing(data: any, contract: any) {
        var url = 'common/genericListing';
        return CommonUtilities.postData(url, data);
    }

    static associatedReleasesWithexclusion(data: any) {
        var url = 'contracts/compilation/associatedReleases/withexclusion?' + CommonUtilities.buildQueryString(data, true, true);
        return CommonUtilities.getData(url);
    }



    /****************************************************************************************
    ********************************contract Link Song********************************
    ****************************************************************************************/
    static contractLinkSong(data: any) {
        var url = 'publishing/song/associatedSongs/link?' + CommonUtilities.buildQueryString(data, true, true);
        return CommonUtilities.getData(url);
    }

    static contractNonLinkSong(data: any) {
        var url = 'publishing/song/associatedSongs/notLink?' + CommonUtilities.buildQueryString(data, true, true);
        return CommonUtilities.getData(url);
    }
    static contractSongotherContract(data: any) {
        var url = 'publishing/song/associatedSongs/otherContract?' + CommonUtilities.buildQueryString(data, true, true);
        return CommonUtilities.getData(url);
    }
    static contractSongReleaseContract(data: any) {
        var url = 'publishing/song/associatedSongs/release?' + CommonUtilities.buildQueryString(data, true, true);
        return CommonUtilities.getData(url);
    }

    static unLinkContractSong(data: any, contract: any) {
        var url = 'publishing/song/associatedSongs/' + contract + '/unLink';
        return CommonUtilities.postData(url, data);
    }

    static linkSongToContract(data: any, contract: any) {
        var url = 'publishing/song/associatedSongs/linkSongToContract/' + contract;
        return CommonUtilities.postData(url, data);
    }


    /****************************************************************************************
    ********************************Song********************************
    ****************************************************************************************/
    static songSplitsSave(data: any) {
        var url = 'publishing/songSplits/save';
        return CommonUtilities.postData(url, data);
    }

}